var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "post-info-section" }, [
    _c("div", { staticClass: "details" }, [
      _c("span", { staticClass: "campaign-title" }, [
        _vm._v("Campaign Name goes here")
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.deliverableDetail.title))]),
      _vm._v(" "),
      _c("hr")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-5" }, [
          _c("h3", [_vm._v("Engagement Manager")]),
          _vm._v(" "),
          _c("span", [_vm._v("Insert Name")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-5" }, [
          _c("h3", [_vm._v("People")]),
          _vm._v(" "),
          _c("ul", { staticClass: "people-list" }, [
            _c("li", [_vm._v("Person One")]),
            _vm._v(" "),
            _c("li", [_vm._v("Person Two")]),
            _vm._v(" "),
            _c("li", [_vm._v("Person Three")]),
            _vm._v(" "),
            _c("li", [_vm._v("Person Four")]),
            _vm._v(" "),
            _c("li", [_vm._v("Person Five")]),
            _vm._v(" "),
            _c("li", [_vm._v("Person Six")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("h3", [_vm._v("Post Status")]),
          _vm._v(" "),
          _c("span", [_vm._v("Status")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details summary" }, [
      _c("h3", [_vm._v("Post Summary")]),
      _vm._v(" "),
      _c("div", { staticClass: "summary-list languages" }, [
        _c("span", [_vm._v("Languages")]),
        _vm._v(" "),
        _c("span", { staticClass: "lang" }, [_vm._v("en")]),
        _vm._v(" "),
        _c("span", { staticClass: "lang" }, [_vm._v("fr")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summary-list platforms" }, [
        _c("span", [_vm._v("Platforms")]),
        _vm._v(" "),
        _c("span", { staticClass: "platform twitter" }, [
          _c("i", { staticClass: "fab fa-x-twitter" })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "platform facebook" }, [
          _c("i", { staticClass: "fab fa-facebook" })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }